module.exports = __webpack_public_path__ + "static/img/post-logo.95c53e24.png";